import React from 'react';
import { useParams } from 'react-router-dom';
import { usePageMeta } from '../../hooks/usePageMeta';
import { NotFound } from '../NotFound';
import { CoursePage } from './CoursePage';
import { courseGroups, courses } from '../../data/courses';
export function ProgrammeDetail() {
  const {
    slug
  } = useParams();
  const course = courses.find(item => item.slug === slug);
  usePageMeta(course?.metaTitle ?? 'Programme not found | ES World', course?.metaDescription ?? 'This page does not exist.');
  if (!course) return <NotFound data-id="element-1300" data-mp="3skxvputpxvtl" />;
  const group = courseGroups.find(item => item.id === course.group);
  return <CoursePage key={course.slug} course={course} groupLabel={group?.label ?? 'Programmes'} data-id="element-1301" data-mp="1ctpyoxnokww" />;
}